import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["memoBox", "memoWrap", "memoInner", "textArea"];

  // 型定義
  declare readonly memoBoxTarget: HTMLElement;
  declare readonly memoWrapTarget: HTMLElement;
  declare readonly memoInnerTarget: HTMLElement;
  declare readonly textAreaTarget: HTMLTextAreaElement;

  connect(): void {
    // TextAreaのカウンター処理はtextarea_counter_controllerに任せる
  }

  edit(): void {
    // 編集ボタンクリック時の処理
    this.memoBoxTarget.classList.add("is_hide");
    this.memoWrapTarget.classList.add("is_show");

    // 現在のメモテキストをテキストエリアに設定
    const currentText = this.memoInnerTarget.textContent?.trim() || "";
    this.textAreaTarget.value = currentText === "メモはありません" ? "" : currentText;
  }

  cancel(): void {
    // キャンセルボタンクリック時の処理
    this.memoBoxTarget.classList.remove("is_hide");
    this.memoWrapTarget.classList.remove("is_show");
  }
}
